// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-frame[data-v-71b10d26] {\n  width: 260px;\n}\n.send-email[data-v-71b10d26] {\n  height: 43px;\n  width: 191px;\n  margin-left: 9px;\n}", ""]);
// Exports
module.exports = exports;
